import React from "react";
const Divider = () => {

return (
  <hr className="divider--thick" />
)
}

export default Divider;